<script setup lang="ts">
import Isic from "@/domains/home/services/configurations/views/nature_of_business/Isic.vue";
</script>

<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <Isic />
    </div>
  </div>
</template>
